import { dataLoader } from './dataLoader.js';
import { dataCache } from './dataCache.js';
import * as turf from '@turf/turf';

const VEIN_DATA_URLS = ['/data/veins.geojson', '/data/veins.json'];

class VeinStore {
  constructor() {
    this.veins = null;
  }

  async init() {
    if (this.veins) return;

    const cached = dataCache.get('veins');
    if (cached) {
      this.veins = cached;
    } else {
      this.veins = await dataLoader.load(VEIN_DATA_URLS);
      dataCache.set('veins', this.veins);
    }
  }

  findNearestVein(lngLat) {
    const point = turf.point(lngLat);
    let minDistance = Infinity;
    let nearestVein = null;

    for (const feature of this.veins.features) {
      const distance = turf.pointToLineDistance(point, feature.geometry, {
        units: 'meters'
      });
      if (distance < minDistance) {
        minDistance = distance;
        nearestVein = feature.properties;
      }
    }

    if (!nearestVein) return null;

    return {
      vein: nearestVein,
      distance: Math.round(minDistance)
    };
  }

  getAllVeins() {
    return this.veins;
  }
}

export const veinStore = new VeinStore();
